import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { CalibracionComponent } from './calibracion/calibracion.component';
import { CalificacionComponent } from './calificacion/calificacion.component';
import { TiendaComponent } from './tienda/tienda.component';
import { ContactoComponent } from './contacto/contacto.component';
import { CapacitacionComponent } from './capacitacion/capacitacion.component';

import { TipoComponent } from './calibracion/tipo/tipo.component';
import { ProductoComponent } from './tienda/producto/producto.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'servicios',
    component: CalibracionComponent,
  },
  {
    path: 'servicios/:id',
    component: TipoComponent,
  },
  {
    path: 'ventas',
    component: TiendaComponent,
  },
  {
    path: 'ventas/producto/:id',
    component: ProductoComponent,
  },
  {
    path: 'capacitacion',
    component: CapacitacionComponent,
  },
  {
    path: 'contacto',
    component: ContactoComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
